<template>
  <div class="columns" style="overflow: hidden;">
    <div class="column is-8 ml-4">
      <ModalApplicant :payload="{ data: this.payload.data }" />
    </div>
    <div class="column b-r">
      <div class="full_width is-flex is-justify-content-space-between">
        <div>
          <button @click="hotPositions" class="button is-outlined is-warning">Offers</button>
        </div>
        <div class="is-flex is-justify-content-space-between">
          <div class="">
            <GhanaFlag :payload="applicant_data" />
          </div>
          <div style="width: 25px;" @click="applicantAnswered">
            <img class="operation_icon mr-6" width="25" src="/applicant_answered.svg" />
          </div>
        </div>
        <div>
          <div class="is-flex is-align-items-center">
            <a v-if="!show_timing_form" @click="showTimingForm" dir="rtl" class="button is-info">קבע מועד חדש ל- Follow Up</a>
            <div v-else class="is-flex is-flex-direction-column">
              <snooze v-model="selected_timing" :selected_date="selected_timing"></snooze>
              <a @click="changeTiming()" class="button is-info timing_submit_button" :class="{ 'is-loading': is_changing_timing }">
                Submit
              </a>
            </div>
          </div>
          <div class="mt-4">
            <a @click="doneAlert" class="button is-info is-outlined" :disabled="isDoneDisabled">Done</a>
          </div>
          <div class="mt-4">
            <a @click="expiredAdvancedAll" class="button is-info is-outlined">Expired Advanced All</a>
          </div>
        </div>
      </div>
      <div>
        <LinkEntity :payload="applicant_data" />
      </div>
      <div>
        <InternalNotes :payload="payload.data" :additional_data="{ resource_type: payload.resource_type }" :is_modal="false" :eager_load="true" />
      </div>
      <div dir="ltr" class="is-flex is-justify-content-center" style="margin-top: 30px;">
        <div v-if="is_loading" class="loading"></div>
        <p v-if="!is_loading && offers.length == 0">NO OFFERS.</p>
      </div>
      <div class="pl-2 mb-4" style="max-height: 650px; overflow-x: auto;">
        <div v-for="offer in offers" :key="offer.id" class="alert_container mb-5 is-size-7">
          <div>
            <div class="mb-3 is-flex is-justify-content-space-between">
              <div class="has-text-right">
                <b>Offer id:</b> {{ offer.id }}
              </div>
              <div class="has-text-left">
                <b>Sent at:</b> {{ $moment(offer.sent_at).format('DD/MM/YYYY') }}
              </div>
            </div>
            <div>
              <div class="is-flex is-align-items-center is-justify-content-space-between mb-4">
                <div class="is-flex is-align-items-center">
                  <b class="p-2">Offer Message: </b>
                  <Message :payload="offer" :additional_data="{ resource_type: 'Offer', endpoint: '/offers/', headers: 'admin_headers' }" />
                </div>

                <OfferStatus :payload="offer" />
              </div>

              <div class="is-flex is-align-items-center is-justify-content-flex-end">
                <div class="is-flex is-align-items-center">
                  <p><b>Position:</b></p>
                  <LinkEntity class="mx-2" :additional_data="{ resource_type: 'Position' }" :payload="offer.position" />
                </div>
                <div class="is-flex is-align-items-center my-5">
                  <p><b>Company:</b></p>
                  <LinkEntity class="mx-2" :additional_data="{ resource_type: 'Company' }" :payload="offer.position.company" />
                </div>
                <div class="is-flex is-align-items-center">
                  <p><b>Name: </b></p>
                  <LinkEntity style="margin-right: 6px;" :payload="offer.applicant" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'

import TextsHelper from '@/custom/classes/texts_helper.js'
import Snooze from '@/components/Snooze'
import GhanaFlag from '@/components/GhanaFlag'
import LinkEntity from '@/components/LinkEntity'
import OfferStatus from '@/components/OfferStatus'
import Message from '@/components/Message'
import ModalApplicant from '@/components/modals/ModalApplicant.vue'
import InternalNotes from '@/components/InternalNotes'

export default {
  name: 'ApplicantAlertsForm',
  components: {
    ModalApplicant,
    Snooze,
    OfferStatus,
    Message,
    GhanaFlag,
    LinkEntity,
    InternalNotes
  },
  props: ['payload'],
  data () {
    return {
      alert: {},
      offers: [],
      texts_helper: new TextsHelper(),
      is_loading: true,
      show_timing_form: false,
      is_changing_timing: false,
      selected_timing: undefined,
      applicant_data: this.payload.data,
      texts: {}
    }
  },
  computed: {
    isDoneDisabled () {
      return this.offers.reduce((prev, curr) => {
        if (['awaiting_applicant_strong', 'system_strong', 'awaiting_company', 'awaiting_company_sent', 'company_never_replied', 'company_process', 'interview', 'received_proposal'].includes(curr.status.name)) {
          return prev || true
        }
        return prev || false
      }, false)
    }
  },
  created () {
    this.getAlert()
    this.getOffers()
    this.init()
  },
  methods: {
    init () {
      this.getTexts()
    },
    getTexts () {
      this.$network_utils.getResourceTexts({
        current_type: 'Applicant',
        current_resource_id: this.applicant_data.resource_id
      }).then(response => {
        this.setTexts(response)
      })
    },
    setTexts (server_response) {
      let temp_texts = {}
      for (let i = 0; i < server_response.length; i++) {
        let text = server_response[i]
        let designator = text.designator
        text.content = this.texts_helper.getContent(text)
        temp_texts[designator] = text
      }
      this.texts = temp_texts
    },
    doneAlert () {
      if (!this.isDoneDisabled) {
        this.$network_utils.postDoneAlert(this.alert, 'done')
      }
    },
    getAlert () {
      this.$network_utils.getResourceAlerts({ current_resource_type: this.payload.resource_type, current_resource_id: this.payload.data.resource_id, designator: 'send_cv' }).then(response => {
        this.alert = { ...response[0] }
      })
    },
    getOffers () {
      let request_data = {
        resource_type: this.payload.resource_type,
        resource_id: this.payload.data.resource_id,
        sort: '-sent_at',
        statuses: 'awaiting_applicant_strong,system_strong,awaiting_company,awaiting_company_sent,company_never_replied,company_process,interview,received_proposal',
        per: 20,
        page: 1
      }
      this.$network_utils.getResourceOffers(request_data).then(response => {
        this.is_loading = false
        this.offers = response
      })
    },
    showTimingForm () {
      this.show_timing_form = true
    },
    expiredAdvancedAll () {
      this.$network_utils.postEvent({
        event: 'expire_advanced_all',
        current_type: 'Applicant',
        current_resource_id: this.applicant_data.resource_id
      }).then(response => {
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      })
    },
    applicantAnswered () {
      this.$network_utils.postStat({
        title: 'Applicant answered phone',
        designator: 'applicant_answered_phone',
        status: 'active',
        owner: this.$utils.getOwner().name,
        priority: 5,
        resource_type: 'Applicant',
        resource_id: this.applicant_data.resource_id
      }).then(() => this.$utils.emit('show_toast', { text: 'success' }))
    },
    async changeTiming () {
      if (this.selected_timing == undefined) {
        this.$utils.emit('show_toast', { text: 'תאריך לא בחור' })
        return
      }
      this.$network_utils.postStat({
        title: 'new internal note',
        designator: 'internal_notes',
        content: `Send cv Changed Timing To <b>${new Date(this.selected_timing).toLocaleString()}</b>`,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 4,
        resource_type: this.payload.resource_type,
        resource_id: this.payload.data.resource_id
      })
      this.is_changing_timing = true
      await this.$network_utils.updateAlert({ id: this.alert.id, timing: this.selected_timing })
      this.is_changing_timing = false
      this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
    },
    hotPositions () {
      this.create({
        designator: 'hot-positions-modal',
        component_name: 'GhanaFlagForm',
        modal_title: 'Hot Positions',
        resource_type: 'Applicant',
        resource_id: this.payload.data.resource_id,
        statuses: 'awaiting_applicant,awaiting_admin,awaiting_applicant_strong,system_strong,awaiting_company,filtered_out',
        isHotPositions: true,
        modal_width: 1000
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style>
  .alert_container{
    width: 100%;
    border-radius: 4px;
    margin-top: 10px;
    padding: 12px;
    border-style: solid;
    border-width: 2px;
    background-color: rgba(0, 0, 0, 0.07);
  }
  .timing_submit_button{
    margin-top: 20px;
  }
  .b-r{
    height: 65vh;
    overflow-y: auto;
  }
</style>
